module.exports = __webpack_public_path__ + "static/media/elephant.71b51083.jpg";